// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","563":"cb355538"}[chunkId] || chunkId) + "-" + {"293":"34b232100a55687479c3","454":"26eae1c2fa9b448fbd11","563":"b3cc24839d42ba101c46"}[chunkId] + ".js";
};